module.exports = __webpack_public_path__ + "img/9788958285540.f542a4f7.jpg";